import { Tag, Typography, Button, Space } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import _get from "lodash/get";

const { Text } = Typography;

const SystemNotificationColumn = ({ onRefresh, pagination }) => {
  const navigate = useNavigate();
  const getPriorityColor = (priority) => {
    switch (priority) {
      case "high":
        return "red";
      case "normal":
        return "blue";
      case "low":
        return "green";
      default:
        return "default";
    }
  };

  const getPriorityText = (priority) => {
    switch (priority) {
      case "high":
        return "Cao";
      case "normal":
        return "Bình thường";
      case "low":
        return "Thấp";
      default:
        return priority;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "green";
      case "inactive":
        return "red";
      default:
        return "default";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "active":
        return "Đang hoạt động";
      case "inactive":
        return "Không hoạt động";
      default:
        return status;
    }
  };

  const stripHtml = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>/g, "");
  };

  return [
    {
      title: "Tiêu đề",
      dataIndex: "title",
      key: "title",
      width: 200,
      render: (text, record) => (
        <div style={{ fontWeight: 500, color: "#333" }}>
          {text || record.metaData?.title || "N/A"}
        </div>
      ),
    },
    {
      title: "Nội dung",
      dataIndex: "message",
      key: "message",
      width: 300,
      render: (text) => (
        <div style={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'normal',
          maxWidth: 300,
        }}>
          {stripHtml(text) || "N/A"}
        </div>
      ),
    },

    {
      title: "Số người dùng nhận được thông báo",
      dataIndex: "affectedUsers",
      key: "affectedUsers",
      width: 150,
      render: (affectedUsers) => (
        <Tag color="orange" style={{ fontWeight: 500 }}>
          {affectedUsers || 0}
        </Tag>
      ),
    },
    {
      title: "SL thiết bị nhận thông báo",
      dataIndex: "numberOfDevices",
      key: "numberOfDevices",
      width: 150,
      render: (numberOfDevices) => (
        <Tag color="blue" style={{ fontWeight: 500 }}>
          {numberOfDevices || 0}
        </Tag>
      ),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (date) => (
        <Text style={{ fontSize: 12, color: "#666" }}>
          {date ? moment(date).format("DD/MM/YYYY HH:mm") : "N/A"}
        </Text>
      ),
    },
    {
      title: "Hành động",
      key: "actions",
      width: 100,
      fixed: "right",
      render: (_, record) => (
        <Space>
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={() => navigate(`/system_notifications/${record._id}`)}
            style={{ color: "#1890ff" }}
            title="Xem chi tiết"
          />
        </Space>
      ),
    },
  ];
};

export default SystemNotificationColumn; 